import { Button, Paper, Typography } from '@mui/material'

const ErrorPage = () => {

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "calc(100vh - 130px)",
        border: "none",
        boxShadow: "none",
      }}
    >
      <Typography variant="h1" sx={{ color: "#24335E" }}>
        Something went wrong
      </Typography>
      <Typography variant="h5" 
      sx={{ color: "#24335E", mt: "10px" }}
      >
        Please try again later or navigate to a different page
      </Typography>
      <Button
        variant={"contained"}
        color={"secondary"}
        onClick={() => window.history.go(-1)}
        sx={{ mt: "16px"}}
      >
        Back
      </Button>
    </Paper>
  )
}

export default ErrorPage
